<template>
  <AtomLink :url="url" :title="title" :class="{ 'border-b-2 hover:border-app-green border-transparent cursor-pointer': url }">
    {{ title }}
  </AtomLink>
</template>

<script setup lang="ts">
interface Props {
  title: string
  url: string
}

defineProps<Props>()
</script>
